import { PATHS } from '../../routing-system/appPaths';
import {
  SET_CURRENT_SIGNUP_PATH,
  SET_HAS_JUST_SIGNED_UP,
  SET_INITIAL_SIGNUP_LOAD,
  SET_IS_AFTER_ZIMPLER_SIGN_UP,
  SET_SIGNUP_CHECKPOINT,
  SET_SIGNUP_CHOICE_DIALOG_OPEN,
  SET_SIGNUP_DIALOG_OPEN,
  SET_USE_SIGNUP_V3,
  SET_ZIMPLER_SIGNUP_DIALOG_OPEN,
  SignupActionType,
  SignupState,
} from '../types/signupTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialSignupState: SignupState = {
  initialSignUpLoad: true,
  currentSignUpPath: PATHS.SIGNUP.STEPS.EMAIL,
  dialogs: {
    signupChoiceDialogOpen: false,
    zimplerSignupDialogOpen: false,
    signupDialogOpen: false,
  },
  signupV3: {
    useSignupV3: false,
    checkpoint: undefined,
  },
  isAfterZimplerSignup: false,
  hasJustSignedUp: false,
};

export const signupReducer = (state = initialSignupState, action: SignupActionType): SignupState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialSignupState,
        isAfterZimplerSignup: state.isAfterZimplerSignup,
      };
    case SET_INITIAL_SIGNUP_LOAD: {
      return { ...state, initialSignUpLoad: action.meta };
    }
    case SET_CURRENT_SIGNUP_PATH: {
      return { ...state, currentSignUpPath: action.meta };
    }
    case SET_USE_SIGNUP_V3: {
      return { ...state, signupV3: { ...state.signupV3, useSignupV3: action.meta } };
    }
    case SET_SIGNUP_CHECKPOINT: {
      return { ...state, signupV3: { ...state.signupV3, checkpoint: action.meta } };
    }
    case SET_SIGNUP_CHOICE_DIALOG_OPEN: {
      return { ...state, dialogs: { ...state.dialogs, signupChoiceDialogOpen: action.meta } };
    }
    case SET_ZIMPLER_SIGNUP_DIALOG_OPEN: {
      return { ...state, dialogs: { ...state.dialogs, zimplerSignupDialogOpen: action.meta } };
    }
    case SET_SIGNUP_DIALOG_OPEN: {
      return { ...state, dialogs: { ...state.dialogs, signupDialogOpen: action.meta } };
    }
    case SET_IS_AFTER_ZIMPLER_SIGN_UP: {
      return { ...state, isAfterZimplerSignup: action.meta };
    }
    case SET_HAS_JUST_SIGNED_UP: {
      return { ...state, hasJustSignedUp: action.meta };
    }
    default:
      return state;
  }
};
